import {useOppsigelse} from "../../api/oppsigelser";
import LoadingSpinner from "../../components/LoadingSpinner";
import {PktAlert, PktTag,} from "@oslokommune/punkt-react";
import {useParams} from "react-router-dom";
import {InfoBox, InfoBoxItem} from "../../components/InfoBox";
import {useEffect} from "react";
import {getDocumentTitle} from "../../utils/documentTitle";

export function OppsigelseStatus() {
  const {id} = useParams()
  const [oppsigelse, oppsigelseResponseStatus] = useOppsigelse(id)
  const barnFulltNavn = [oppsigelse?.barnFornavn, oppsigelse?.barnEtternavn].join(' ')
  const ønsketDato = oppsigelse?.ønsketDato && new Date(oppsigelse.ønsketDato).toLocaleDateString('no', {dateStyle: 'long'})

  useEffect(() => {
    document.title = getDocumentTitle("oppsigelse-status")
  })

  function getStatusTag() {
    if (!oppsigelse) return
    if (oppsigelse.status === 'GODKJENT') {
      return <PktTag skin={'green'} size={'small'}>Godkjent</PktTag>
    } else if (oppsigelse.status === 'AVSLÅTT') {
      return <PktTag skin={'red'} size={'small'}>Avslått</PktTag>
    } else {
      return <PktTag skin={'yellow'} size={'small'}>Under behandling</PktTag>
    }
  }


  return (
    <div className="pkt-cell pkt-cell--span12">
      <h1 className={'pkt-txt-40'}>
        Oppsigelse av barnehageplass
      </h1>

      {oppsigelseResponseStatus === 'pending' && (
        <LoadingSpinner/>
      )}

      {oppsigelseResponseStatus === 'error' && (
        <PktAlert skin={'error'} className={"mt-size-40"}>
          Det skjedde en feil. Vennligst prøv igjen senere.
        </PktAlert>
      )}
      {oppsigelseResponseStatus === 'ready' && (
        <InfoBox className={`mt-size-30 p-size-20`}>
          <InfoBoxItem title={'Status'}>{getStatusTag()}</InfoBoxItem>
          {oppsigelse?.merknad && (
            <InfoBoxItem title={'Informasjon fra saksbehandler'}>
              <span style={{whiteSpace: 'pre'}}>{oppsigelse.merknad}</span>
            </InfoBoxItem>
          )}
          <InfoBoxItem title={'Navn'}>{barnFulltNavn}</InfoBoxItem>
          <InfoBoxItem title={'Barnehage'}>{oppsigelse?.barnehageNavn}</InfoBoxItem>
          <InfoBoxItem title={'Årsak til oppsigelse'}>{oppsigelse?.grunn}</InfoBoxItem>
          <InfoBoxItem title={'Ønsket siste dag i barnehagen'}>{ønsketDato}</InfoBoxItem>
        </InfoBox>
      )}
    </div>
  )
}

